// extracted by mini-css-extract-plugin
export default {"cookiePolicy":"CookiePolicy_cookiePolicy__lXRbm","cookieTable":"CookiePolicy_cookieTable__rLjFP"};